export const apiConstants = {
  GetAll: 'services/app/TeeConfiguration/GetAll',
  Create: 'services/app/TeeConfiguration/Create',
  CreateDay: 'services/app/TeeConfigurationDay/Create',
  UpdateDay: 'services/app/TeeConfigurationDay/UpdateDay',
  DeleteDay: 'services/app/TeeConfigurationDay/DeleteDay',
  GetAllDays: 'services/app/TeeConfigurationDay/GetByConfigId',
  OverrideDay: 'services/app/TeeConfigurationDayOverride/Create',
  GetOverrideDay: 'services/app/TeeConfigurationDayOverride/GetOverride',
};
